<div class="fx-row fx-layout-gap-32">
    <!-- Left column: jobs -->
    <div class="fx-flex-30 fx-column">
        <div class="header">
            <h3>Job list</h3>

            <div class="space fx-flex"></div>

            <!-- Create new job (Close details button) -->
            <button *ngIf="selectedJob$ | async" mat-stroked-button class="fx-flex-nogrow" (click)="selectJob(null)">
                NEW JOB
            </button>
        </div>

        <!-- Section: Ongoing jobs-->
        <section *ngIf="(ongoingJobs$ | async)?.length; else noOngoing">
            <h4>Current jobs</h4>
            <ng-container *ngFor="let job of ongoingJobs$ | async">
                <ng-container
                    *ngTemplateOutlet="jobEntry; context: { job: job, selected: isJobSelected(job.jobId) }"
                ></ng-container>
            </ng-container>
        </section>
        <ng-template #noOngoing>
            <h4 class="muted" i18n>No ongoing jobs</h4>
        </ng-template>

        <!-- Section: History jobs-->
        <section *ngIf="(historyJobs$ | async)?.length; else noHistory">
            <h4>History jobs</h4>
            <ng-container *ngFor="let job of historyJobs$ | async">
                <ng-container
                    *ngTemplateOutlet="jobEntry; context: { job: job, selected: isJobSelected(job.jobId) }"
                ></ng-container>
            </ng-container>
        </section>
        <ng-template #noHistory>
            <h4 class="muted">No history</h4>
        </ng-template>
    </div>

    <!-- Right column: Dropzone + Job details -->
    <div class="fx-flex-60">
        <ng-container *ngIf="selectedJob$ | async; else uploadSection" [ngTemplateOutlet]="detailsSection">
        </ng-container>
    </div>
</div>

<ng-template #uploadSection>
    <section>
        <!--Title-->
        <div class="header">
            <h3>Upload package</h3>
        </div>

        <!-- Certificate Type Selection For Signing Job -->
        <div class="certificate-toggle">
            <mat-slide-toggle
                [disabled]="!allowSignGenericDeviceCertificate"
                [(ngModel)]="signStationCertificate"
                [matTooltip]="'When enabled, the signing job will be associated with the current stationId and serial number. When disabled, create a certificate signing request for a generic device.'"
                matTooltipPosition="left"
            >
                Sign
                {{
                    signStationCertificate ? stationSpecificCertText.toLowerCase() : genericDeviceCertText.toLowerCase()
                }}
            </mat-slide-toggle>
        </div>

        <!--Drop Zone-->
        <div
            class="dropzone fx-align-center-center fx-row"
            (click)="fileInput.click()"
            [uploader]="uploader"
            (onFileDrop)="selectFileWithDrop($event)"
            ng2FileDrop
            csmsDragAndDrop
        >
            <input
                type="file"
                #fileInput
                class="file-input"
                (onFileSelected)="selectFileWithInput($event)"
                ng2FileSelect
            />

            <div class="fx-align-center-center">
                <mat-icon svgIcon="cloud-upload-outline"></mat-icon>
                <span>&nbsp;</span>
                <span>Drag and drop file here or click to browse</span>
            </div>
        </div>

        <!-- Upload details-->
        <div class="upload-details" *ngFor="let item of uploader.queue; trackBy: trackByJobId">
            <ce-progress-bar [fileName]="item._file.name" [progress]="item.progress" (remove)="item.remove()">
            </ce-progress-bar>
        </div>
    </section>
</ng-template>

<ng-template #detailsSection>
    <section>
        <!-- Header: Job title, status, refresh, close -->
        <div class="header" *ngIf="selectedJob$ | async as selected">
            <!-- Job Status & File name -->
            <div class="fx-row fx-align-start-center fx-layout-gap-8">
                <ng-container *ngTemplateOutlet="jobStatus; context: { job: selected }"></ng-container>
                <h3 class="ellipsis">{{ selected?.fileName }}</h3>
            </div>

            <!-- Refresh button -->
            <div class="fx-row fx-align-end-center fx-flex-noshrink">
                <button mat-icon-button (click)="getJobStatus(selected.jobId)">
                    <mat-icon svgIcon="refresh"></mat-icon>
                </button>
                <div [matTooltip]="selected.statusTimestamp" [matTooltipPosition]="'above'" class="ellipsis muted">
                    Updated at: {{ selected.statusTimestamp | date: 'medium' }}
                </div>
            </div>

            <!-- Close button -->
            <button class="fx-flex-nogrow" mat-icon-button (click)="selectJob(null)">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </div>

        <!-- Body: Job meta, timeline, raw JSON -->
        <ng-container *ngIf="selectedJob$ | async as selected">
            <div class="fx-column fx-layout-gap-16">
                <!-- Job meta -->
                <div>
                    <p><span class="title">Job ID:</span> {{ selected.jobId }}</p>
                    <p *ngIf="selected.createdAt">
                        <span class="title">Created at:</span> {{ selected.createdAt | date: 'medium' }}
                    </p>
                    <p *ngIf="selected.completedAt">
                        <span class="title">Completed at:</span> {{ selected.completedAt | date: 'medium' }}
                    </p>
                    <p *ngIf="selected.completedAt">
                        <span class="title">Signing job type:</span>
                        {{ selected.stationId ? stationSpecificCertText : genericDeviceCertText }}
                    </p>
                </div>

                <!-- Job timeline -->
                <ng-container *ngTemplateOutlet="jobTimeline; context: { job: selected }"></ng-container>

                <!-- Buttons -->
                <div class="fx-row fx-layout-gap-16">
                    <!-- JSON toggle -->
                    <button mat-raised-button (click)="toggleRawJson()" (enter)="toggleRawJson()">
                        {{ this.showRawJson ? 'HIDE' : 'SHOW' }} RAW JSON
                    </button>

                    <!-- Download button -->
                    <button
                        *ngIf="selected.downloadUrl"
                        mat-raised-button
                        (click)="openDownload(selected.downloadUrl)"
                        (enter)="openDownload(selected.downloadUrl)"
                    >
                        Download
                    </button>
                </div>

                <!-- Raw JSON -->
                <div class="rawJson">
                    <textarea *ngIf="showRawJson" disabled>{{ selected | json }}</textarea>
                </div>
            </div>
        </ng-container>
    </section>
</ng-template>

<ng-template #jobEntry let-job="job" let-selected="selected">
    <div
        class="job-entry fx-row fx-layout-gap-8"
        [ngClass]="{
            'status-failed-border': job.status === 'failed',
            'status-active-border': job.status === 'processing',
            'status-completed-border': job.status === 'completed',
            'status-queued-border': job.status === 'queued',
            'default-border': !job.status,
            'selected-border': selected === true,
        }"
        role="button"
        tabindex="0"
        [matTooltip]="job.fileName"
        [matTooltipPosition]="'above'"
        (click)="selectJob(job.jobId)"
        (keydown.enter)="selectJob(job.jobId)"
    >
        <div class="ellipsis fx-flex-80">{{ job.fileName }}</div>
        <ng-container *ngTemplateOutlet="jobStatus; context: { job: job }"></ng-container>
    </div>
</ng-template>

<ng-template #jobTimeline let-job="job">
    <div class="fx-column fx-layout-gap-12">
        <!-- Step 1: Initialization -->
        <div
            class="fx-row fx-align-start-center fx-layout-gap-8 step"
            [ngClass]="{
                'status-active': job.initStatus === 'initializing',
                'status-failed': job.initStatus === 'failed',
                'status-completed': job.initStatus === 'initialized',
            }"
        >
            <ng-container [ngSwitch]="job.initStatus">
                <mat-spinner *ngSwitchCase="'initializing'" [diameter]="20"></mat-spinner>
                <mat-icon *ngSwitchCase="'failed'" class="error" svgIcon="close"></mat-icon>
                <mat-icon *ngSwitchCase="'initialized'" class="success" svgIcon="check"></mat-icon>
                <mat-icon *ngSwitchDefault class="muted" svgIcon="hourglass-empty"></mat-icon>
            </ng-container>
            <div>
                <div *ngIf="job.initStatus === 'initializing'">Initializing request...</div>
                <div *ngIf="job.initStatus === 'initialized'">Request initialized</div>
                <div *ngIf="job.initStatus === 'failed'">Initialization failed</div>
                <div *ngIf="!job.initStatus" class="muted">Pending initialization</div>
            </div>
        </div>

        <!-- Step 2: Upload -->
        <div
            class="fx-row fx-align-start-center fx-layout-gap-8 step"
            [ngClass]="{
                'status-active': job.uploadStatus === 'uploading',
                'status-failed': job.uploadStatus === 'failed',
                'status-completed': job.uploadStatus === 'uploaded',
            }"
        >
            <ng-container [ngSwitch]="job.uploadStatus">
                <mat-spinner *ngSwitchCase="'uploading'" [diameter]="20"></mat-spinner>
                <mat-icon *ngSwitchCase="'failed'" class="error" svgIcon="close"></mat-icon>
                <mat-icon *ngSwitchCase="'uploaded'" class="success" svgIcon="check"></mat-icon>
                <mat-icon *ngSwitchDefault class="muted" svgIcon="cloud-upload-outline"></mat-icon>
            </ng-container>
            <div>
                <div *ngIf="job.uploadStatus === 'uploading'">Uploading package...</div>
                <div *ngIf="job.uploadStatus === 'uploaded'">Package uploaded</div>
                <div *ngIf="job.uploadStatus === 'failed'">Upload failed</div>
                <div *ngIf="!job.uploadStatus" class="muted">Pending upload</div>
            </div>
        </div>

        <!-- Step 3: Signing -->
        <div
            class="fx-row fx-align-start-center fx-layout-gap-8 step"
            [ngClass]="{
                'status-active': job.status === 'processing',
                'status-failed': job.status === 'failed',
                'status-completed': job.status === 'completed',
            }"
        >
            <ng-container [ngSwitch]="job.status">
                <mat-spinner *ngSwitchCase="'processing'" [diameter]="20"></mat-spinner>
                <mat-icon *ngSwitchCase="'failed'" class="error" svgIcon="close"></mat-icon>
                <mat-icon *ngSwitchCase="'completed'" class="success" svgIcon="check"></mat-icon>
                <mat-icon *ngSwitchDefault class="muted" svgIcon="signature"></mat-icon>
            </ng-container>
            <div>
                <div *ngIf="job.status === 'processing'">Signing in progress...</div>
                <div *ngIf="job.status === 'completed'">Signing completed</div>
                <div *ngIf="job.status === 'failed'">Signing failed</div>
                <div *ngIf="job.status === 'queued' || !job.status" class="muted">Pending signing</div>
            </div>
        </div>

        <ng-container *ngTemplateOutlet="certReqSummary; context: { job: job }"></ng-container>
    </div>
</ng-template>

<ng-template #jobStatus let-job="job">
    <div
        class="badge"
        [ngClass]="{
            'status-failed status-failed-background': job.status === 'failed',
            'status-completed status-completed-background': job.status === 'completed',
            'status-active status-active-background': job.status === 'processing' || job.status === 'signing',
            'status-queued status-queued-background': job.status === 'queued' || job.status === 'pending',
        }"
    >
        {{ job.status }}
    </div>
</ng-template>

<ng-template #certReqSummary let-job="job">
    <div class="cert-requests-summary" *ngIf="job?.certificateRequests?.length">
        <div class="fx-row fx-align-start-center fx-layout-gap-8 cursor-pointer">
            <mat-icon (click)="toggleCertReqTree()">{{ showCertReqTree ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <div class="title" (click)="toggleCertReqTree()" role="button" tabindex="0">
                Certificate requests ({{ job.certificateRequests.length }})
            </div>
        </div>
        <div *ngIf="showCertReqTree">
            <ng-container
                *ngTemplateOutlet="certReqTree; context: { requests: job.certificateRequests }"
            ></ng-container>
        </div>
    </div>
</ng-template>
<ng-template #certReqTree let-requests="requests">
    <div class="cert-requests-tree" *ngIf="requests?.length">
        <div class="children">
            <div
                class="tree-row leaf"
                *ngFor="let r of requests; let last = last; trackBy: trackByRequestId"
                [class.last]="last"
            >
                <span class="junction-dot"></span>
                <!-- status icon & file name -->
                <div
                    class="fx-row fx-align-start-center fx-layout-gap-8"
                    [ngClass]="{
                        'status-failed': r.status === 'failed',
                        'status-completed': r.status === 'completed',
                        'status-active': r.status === 'signing',
                        'status-queued': r.status === 'pending',
                    }"
                >
                    <ng-container [ngSwitch]="r.status">
                        <mat-spinner *ngSwitchCase="'signing'" [diameter]="20"></mat-spinner>
                        <mat-icon *ngSwitchCase="'failed'" class="error" svgIcon="close"></mat-icon>
                        <mat-icon *ngSwitchCase="'completed'" class="success" svgIcon="check"></mat-icon>
                    </ng-container>
                    <div class="title">{{ r.fileName }}</div>
                </div>
                <!-- details -->
                <div class="fx-column fx-layout-gap-8">
                    <!-- main: format & type -->
                    <div class="fx-row fx-layout-gap-8">
                        <div class="badge status-queued status-queued-background">{{ r.format }}</div>
                        <div class="muted">{{ r.certificateType }}</div>
                    </div>
                    <!-- status badge & error (if available) -->
                    <div class="fx-row fx-layout-gap-8">
                        <ng-container *ngTemplateOutlet="jobStatus; context: { job: r }"></ng-container>
                        <div *ngIf="r.error" class="errorMsg">Error: {{ r.error }}</div>
                    </div>
                    <!-- updated time -->
                    <div class="muted">Updated at: {{ r.updatedAt | date: 'mediumTime' }}</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
